/**
 * Describes the loading states of the Dashboard Study Viewer.
 */
export enum DashboardStudyViewerLoadingState {
  notInitialized = 'notInitialized',
  viewerInitialization = 'viewerInitialization',
  calculatingChanges = 'calculatingChanges',
  loadingFiles = 'loadingFiles',
  updatingViewPerspective = 'updatingViewPerspective',
  updatingScanControls = 'updatingScanControls',
  updatingSurfaceControls = 'updatingSurfaceControls',
  renderingViewer = 'renderingViewer',
  viewerRendered = 'viewerRendered',
}

/**
 * Maps the loading states to user-friendly labels.
 */
export const DashboardStudyViewerLoadingStateLabels: Record<DashboardStudyViewerLoadingState, string> = {
  [DashboardStudyViewerLoadingState.notInitialized]: '', // Don't show anything when the initialization wasn't triggered yet
  [DashboardStudyViewerLoadingState.viewerInitialization]: 'initializing viewer',
  [DashboardStudyViewerLoadingState.calculatingChanges]: 'Calculating changes',
  [DashboardStudyViewerLoadingState.loadingFiles]: 'loading files',
  [DashboardStudyViewerLoadingState.updatingViewPerspective]: 'updating view perspective',
  [DashboardStudyViewerLoadingState.updatingScanControls]: 'updating scan controls',
  [DashboardStudyViewerLoadingState.updatingSurfaceControls]: 'updating surface controls',
  [DashboardStudyViewerLoadingState.renderingViewer]: 'rendering viewer',
  [DashboardStudyViewerLoadingState.viewerRendered]: '', // Don't show the loader when the viewer is rendered
}
